import React, { useEffect } from 'react';
import './LegalPage.css';

function TermsPage() {
  useEffect(() => {
    document.title = '이용약관 - 로또운세';
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>📋 이용약관</h1>
        <p className="updated-date">최종 수정일: 2026년 2월 17일</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>제1조 (목적)</h2>
          <p>
            본 약관은 로또운세(이하 "서비스")가 제공하는 로또 번호 추천 및
            운세 서비스의 이용과 관련하여 서비스와 이용자 간의 권리, 의무 및
            책임사항을 규정함을 목적으로 합니다.
          </p>
        </section>

        <section>
          <h2>제2조 (용어의 정의)</h2>
          <ul>
            <li>
              <strong>"서비스"</strong>란 로또운세가 제공하는 로또 번호 생성,
              운세 콘텐츠, 통계 분석 등 모든 서비스를 의미합니다.
            </li>
            <li>
              <strong>"이용자"</strong>란 본 서비스에 접속하여 본 약관에 따라
              서비스를 이용하는 모든 사람을 의미합니다.
            </li>
            <li>
              <strong>"콘텐츠"</strong>란 서비스가 제공하는 로또 번호, 운세,
              통계 정보 등 모든 정보를 의미합니다.
            </li>
          </ul>
        </section>

        <section>
          <h2>제3조 (약관의 효력 및 변경)</h2>
          <p>
            본 약관은 서비스를 이용하는 모든 이용자에게 적용됩니다.
            서비스는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을
            개정할 수 있으며, 개정 시 웹사이트를 통해 공지합니다.
          </p>
        </section>

        <section>
          <h2>제4조 (서비스의 제공)</h2>
          <p>서비스는 다음과 같은 내용을 제공합니다:</p>
          <ul>
            <li>로또 번호 생성 서비스 (7가지 알고리즘)</li>
            <li>12별자리, 12띠, 타로 운세 서비스</li>
            <li>로또 당첨 번호 통계 및 분석</li>
            <li>블로그 및 정보 콘텐츠</li>
          </ul>
        </section>

        <section>
          <h2>제5조 (서비스의 중단)</h2>
          <p>
            서비스는 다음 각 호의 경우 서비스 제공을 일시적으로 중단할 수 있습니다:
          </p>
          <ul>
            <li>시스템 점검, 보수, 교체 등이 필요한 경우</li>
            <li>정전, 통신 장애 등 불가피한 사유가 발생한 경우</li>
            <li>서비스 이용 폭주 등으로 정상적인 서비스 제공이 어려운 경우</li>
            <li>기타 천재지변, 국가비상사태 등이 발생한 경우</li>
          </ul>
        </section>

        <section>
          <h2>제6조 (이용자의 의무)</h2>
          <p>이용자는 다음 행위를 해서는 안 됩니다:</p>
          <ul>
            <li>타인의 정보 도용</li>
            <li>서비스의 운영을 방해하는 행위</li>
            <li>서비스의 정보를 무단으로 수집, 복제, 배포하는 행위</li>
            <li>허위 정보를 게시하거나 음란, 폭력적인 내용을 게시하는 행위</li>
            <li>기타 관련 법령에 위배되는 행위</li>
          </ul>
        </section>

        <section>
          <h2>제7조 (책임의 제한)</h2>
          <p>
            서비스는 다음 각 호의 경우 책임을 지지 않습니다:
          </p>
          <ul>
            <li>
              <strong>당첨 보장 불가:</strong> 본 서비스가 제공하는 로또 번호는
              참고용이며, 당첨을 보장하지 않습니다.
            </li>
            <li>
              <strong>운세의 정확성:</strong> 운세 콘텐츠는 오락 및 재미 목적이며,
              실제 미래를 예측하지 않습니다.
            </li>
            <li>
              천재지변, 전쟁, 시스템 장애 등 불가항력으로 인한 서비스 중단
            </li>
            <li>
              이용자의 귀책사유로 인한 서비스 이용 장애
            </li>
          </ul>
        </section>

        <section>
          <h2>제8조 (저작권)</h2>
          <p>
            서비스가 제공하는 모든 콘텐츠의 저작권은 서비스에 귀속됩니다.
            이용자는 서비스가 제공하는 콘텐츠를 무단으로 복제, 배포, 전송할 수 없습니다.
          </p>
        </section>

        <section>
          <h2>제9조 (분쟁 해결)</h2>
          <p>
            서비스와 이용자 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에
            제기합니다.
          </p>
        </section>

        <section className="notice-box warning">
          <h3>⚠️ 중요 고지사항</h3>
          <p>
            <strong>과도한 로또 구매는 경제적 어려움을 초래할 수 있습니다.</strong><br/>
            본 서비스는 재미와 참고용으로만 사용하시기 바라며,
            책임감 있는 소비를 권장합니다.
          </p>
        </section>

        <section>
          <h2>부칙</h2>
          <p>본 약관은 2026년 2월 17일부터 시행됩니다.</p>
        </section>
      </div>
    </div>
  );
}

export default TermsPage;
